import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ko from './locales/ko.json';
import en from './locales/en.json';
import zh from './locales/zh.json';
import ja from './locales/ja.json';

import toolsKo from './locales/tools/ko.json';
import toolsEn from './locales/tools/en.json';
import toolsZh from './locales/tools/zh.json';
import toolsJa from './locales/tools/ja.json';

import communityKo from './locales/community/ko.json';
import communityEn from './locales/community/en.json';
import communityZh from './locales/community/zh.json';
import communityJa from './locales/community/ja.json';

import subscriptionKo from './locales/subscription/ko.json';
import subscriptionEn from './locales/subscription/en.json';
import subscriptionZh from './locales/subscription/zh.json';
import subscriptionJa from './locales/subscription/ja.json';

import resetPasswordKo from './locales/resetPassword/ko.json';
import resetPasswordEn from './locales/resetPassword/en.json';
import resetPasswordZh from './locales/resetPassword/zh.json';
import resetPasswordJa from './locales/resetPassword/ja.json';

import legalKo from './locales/legal/ko.json';
import legalEn from './locales/legal/en.json';
import legalZh from './locales/legal/zh.json';
import legalJa from './locales/legal/ja.json';

import dashboardKo from './locales/dashboard/ko.json';
import dashboardEn from './locales/dashboard/en.json';
import dashboardZh from './locales/dashboard/zh.json';
import dashboardJa from './locales/dashboard/ja.json';

import memberActivityKo from './locales/memberActivity/ko.json';
import memberActivityEn from './locales/memberActivity/en.json';
import memberActivityZh from './locales/memberActivity/zh.json';
import memberActivityJa from './locales/memberActivity/ja.json';

import chatAttachmentsKo from './locales/chatAttachments/ko.json';
import chatAttachmentsEn from './locales/chatAttachments/en.json';
import chatAttachmentsZh from './locales/chatAttachments/zh.json';
import chatAttachmentsJa from './locales/chatAttachments/ja.json';

import avatarEditKo from './locales/avatarEdit/ko.json';
import avatarEditEn from './locales/avatarEdit/en.json';
import avatarEditZh from './locales/avatarEdit/zh.json';
import avatarEditJa from './locales/avatarEdit/ja.json';

import difyKo from './locales/dify/ko.json';
import difyEn from './locales/dify/en.json';
import difyZh from './locales/dify/zh.json';
import difyJa from './locales/dify/ja.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'ko', label: '한국어', short: 'KO' },
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'zh', label: '中文', short: 'ZH' },
  { code: 'ja', label: '日本語', short: 'JA' },
];

const STORAGE_KEY = 'lansly-lang';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ko: {
        translation: ko,
        tools: toolsKo,
        community: communityKo,
        subscription: subscriptionKo,
        resetPassword: resetPasswordKo,
        legal: legalKo,
        dashboard: dashboardKo,
        memberActivity: memberActivityKo,
        chatAttachments: chatAttachmentsKo,
        avatarEdit: avatarEditKo,
        dify: difyKo,
      },
      en: {
        translation: en,
        tools: toolsEn,
        community: communityEn,
        subscription: subscriptionEn,
        resetPassword: resetPasswordEn,
        legal: legalEn,
        dashboard: dashboardEn,
        memberActivity: memberActivityEn,
        chatAttachments: chatAttachmentsEn,
        avatarEdit: avatarEditEn,
        dify: difyEn,
      },
      zh: {
        translation: zh,
        tools: toolsZh,
        community: communityZh,
        subscription: subscriptionZh,
        resetPassword: resetPasswordZh,
        legal: legalZh,
        dashboard: dashboardZh,
        memberActivity: memberActivityZh,
        chatAttachments: chatAttachmentsZh,
        avatarEdit: avatarEditZh,
        dify: difyZh,
      },
      ja: {
        translation: ja,
        tools: toolsJa,
        community: communityJa,
        subscription: subscriptionJa,
        resetPassword: resetPasswordJa,
        legal: legalJa,
        dashboard: dashboardJa,
        memberActivity: memberActivityJa,
        chatAttachments: chatAttachmentsJa,
        avatarEdit: avatarEditJa,
        dify: difyJa,
      },
    },
    ns: [
      'translation',
      'tools',
      'community',
      'subscription',
      'resetPassword',
      'legal',
      'dashboard',
      'memberActivity',
      'chatAttachments',
      'avatarEdit',
      'dify',
    ],
    defaultNS: 'translation',
    fallbackLng: 'ko',
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    // 브라우저 언어(en-US 등)를 en 으로 축약해 매칭
    load: 'languageOnly',
    detection: {
      // localStorage 우선, 없으면 브라우저 언어
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: STORAGE_KEY,
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // React 가 XSS 방어를 하므로 이스케이프 불필요
    },
    returnEmptyString: false, // 빈 문자열이면 fallback 사용
  });

// 문서 메타 동기화 — <html lang>·<title>·<meta description> 를 언어에 맞춰 갱신
// (index.html 의 정적 <title> 은 초기값일 뿐, 앱 로드/언어 전환 시 여기서 덮어씀)
const applyDocumentMeta = () => {
  document.documentElement.setAttribute('lang', i18n.resolvedLanguage || 'ko');
  const title = i18n.t('meta.title');
  if (title) document.title = title;
  const desc = i18n.t('meta.description');
  const descEl = document.querySelector('meta[name="description"]');
  if (descEl && desc) descEl.setAttribute('content', desc);
};
applyDocumentMeta();
i18n.on('languageChanged', applyDocumentMeta);

export default i18n;
